import React, { Dispatch, SetStateAction } from "react"
import { Button, IButtonProps } from "./common/Button"
import Modal from "./common/Modal"
import { Spinner } from "./common/Spinner"

type Props = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onCancel: () => void
  onConfirm: () => void
  body: any
  header: any
  cancelText?: string
  confirmText?: string
  confirmVariant?: IButtonProps["variant"]
  loading?: boolean
}

export const ConfirmModal: React.FC<Props> = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
  body,
  header,
  cancelText,
  confirmText,
  confirmVariant,
  loading,
}: Props) => {
  return (
    <Modal open={open} setOpen={setOpen}>
      <header className="text-base leading-6 font-semibold text-gray-900">{header}</header>

      <div className="mt-2">
        <p className="text-sm text-gray-600">{body}</p>
      </div>
      <div className="mt-5 gap-x-3 sm:mt-4 sm:flex sm:justify-end">
        <Button variant="secondary" onClick={onCancel}>
          {cancelText || "No"}
        </Button>
        <Button variant={confirmVariant ?? "primary"} disabled={loading} onClick={onConfirm}>
          {loading ? (
            <>
              <Spinner /> Loading...
            </>
          ) : (
            <>{confirmText || "Yes"}</>
          )}
        </Button>
      </div>
    </Modal>
  )
}
